import quoteGQLString from '../../util/quoteGQLString';

export default (approval) => `
    id: ${quoteGQLString(approval?.id)}
`;
